export default {
  init() {
    // JavaScript to be fired on the home page
    $( document ).ready(function() {

      $('.services-slider').owlCarousel({
          loop:true,
          margin:0,
          dots: false,
          nav:false,
          autoplay: true,
          autoplayTimeout:10000,
          autoplaySpeed: 3000,
          smartSpeed: 3000,
          responsive:{
              0:{
                  items:1
              }
          }
      });
  
      $('.articles-slider').owlCarousel({
          loop:true,
          margin:0,
          dots: false,
          nav:false,
          autoplay: true,
          autoplayTimeout:10000,
          autoplaySpeed: 3000,
          smartSpeed: 3000,
          responsive:{
              0:{
                  items:1
              }
          }
      });
  
      $('.clients-slider').owlCarousel({
          loop:true,
          dots: false,
          nav:false,
          autoplay: true,
          autoplayTimeout:10000,
          autoplaySpeed: 3000,
          smartSpeed: 3000,
          responsive:{
              0:{
                  margin: 5,
                  items:3
              },
              576:{
                  margin: 10,
                  items:3
              },
              992:{
                  margin: 20,
                  items:5
              }
          }
      });
  
      $('.proposal-list-slider').owlCarousel({
          loop:true,
          dots: false,
          nav:false,
          autoplay: true,
          autoplayTimeout:5000,
          autoplaySpeed: 2000,
          smartSpeed: 2000,
          items:1,
      });
    });

    window.onload = function () {
        let instagram_content = $('.elfsight-app-86fe4874-2e1e-4f7a-b7f8-617fb30e359c').html();
    };
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};